<app-admin-header *ngIf="hasAccess(['ADMIN'])"></app-admin-header>
<app-mda-header *ngIf="hasAccess(['MDA'])"></app-mda-header>

<div class="container mt-4 px-5">

    <div class="row">
        <div class="d-flex justify-content-end mb-3 mt-3">
            <button class="btn btn-sm custom-btn me-3" (click)="open(generate_bill)">
                <span class="mdi mdi-plus custom-icon"></span>
                Generate New Bill
            </button>
        </div>
    </div>


    <div class="card">
        <div class="card-body px-2">
            
            <div class="d-flex justify-content-end">
                <button class="custom-search-button" (click)="toggleSearch()">
                    Search
                    <span class="mdi mdi-magnify custom-search-icon"></span>
                </button>
            </div>
            <div class="search-parameters" *ngIf="showSearch">
                <form class="search-form" [formGroup]="assessmentSearchForm">
                    <button class="btn btn-outline-secondary btn-sm position-absolute top-0 end-0"
                        (click)="toggleSearch()">
                        <span class="mdi mdi-close"></span>
                    </button>
                    <div class="row mt-2">

                        <div class="col-md-3">
                            <label>Invoice Number</label>
                            <input type="text" class="form-control small-option-font" formControlName="invoice" />

                        </div>

                        <div class="col-md-3">
                            <label>ASIN</label>
                            <input type="text" class="form-control small-option-font" formControlName="asin" />

                        </div>

                        <div class="col-md-3">
                            <label>Payment Status</label>
                            <select class="form-control small-option-font" formControlName="paymentStatus">
                                <option value="">-- Select--</option>
                                <option value="PAID">PAID</option>
                                <option value="PENDING">PENDING</option>
                            </select>
                        </div>

                        <!-- <div class="col-md-3">
                            <label>Payment Status</label>
                            <select class="form-control small-option-font" formControlName="paymentStatus">
                                <option value="">-- Select--</option>
                                <option value="PAID">Paid</option>
                                <option value="NOT_PAID">Not Paid</option>
                            </select>
                        </div> -->

                        <!-- <div class="col-md-3">
                            <label>Filing Year</label>
                            <select class="form-control small-option-font" formControlName="assessmentYear">
                                <option value="">-- Select Year --</option>
                                <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                            </select>
                        </div> -->

                        <div class="col-md-3">
                            <label>Start Date</label>
                            <input type="date" class="form-control small-option-font" formControlName="from" />
                        </div>
                        <div class="col-md-3">
                            <label>End Date</label>
                            <input type="date" class="form-control small-option-font" formControlName="to" />
                        </div>

                    </div>

                    <div class="row mb-2 justify-content-end">
                        <div class="col-md-3 col-sm-9">
                            <button [disabled]="!assessmentSearchForm.valid" class="btn btn-sm search-button"
                                (click)="search(); toggleSearch()" type="submit">
                                Search
                            </button>
                        </div>
                    </div>

                </form>

            </div>
         

        </div>
    </div>
    <div class="bg-white rounded">
        <div class="reports-heading mb-0 mt-2 px-3 rounded-top-3" style="background-color: rgba(169, 130, 4, 1)" #table>
            <div class="ms-1 top-bar-div">
                <div class="my-2 text-white">
                    <h6>General Bill History</h6>
                </div>
            </div>

        </div>

        <table class="table table-striped table-hover table-bordered px-3">
            <thead class="table-dark">
                <tr>
                    <th class="assess-table-head">S/N</th>
                    <th class="assess-table-head">Invoice Number</th>
                    <th class="assess-table-head">MDA Name</th>
                    <th class="assess-table-head">ASIN</th>
                    <th class="assess-table-head">Revenue Name</th>
                    <th class="assess-table-head">Revenue Code</th>
                    <th class="assess-table-head">Date Created</th>
                    <th class="assess-table-head">Amount</th>
                    <th class="assess-table-head">Payment Status</th>
                    <th class="assess-table-head">Action</th>
                </tr>
            </thead>
            <ng-container *ngIf="!isSearching && details?.length > 0; else noDataTemplate">
                <tbody>
                    <tr *ngFor="let d of details; let i = index">
                        <td>
                            <span class="badge bg-dark">{{ i + 1 + num }}</span>
                        </td>
                        <td>{{ d?.invoiceNumber ? d?.invoiceNumber : "--" }}</td>
                        <td>{{ d?.mdaName | titlecase }}</td>
                        <td>{{ d?.taxpayerAsin | uppercase }}</td>
                        <td>{{ d?.revenueName | titlecase }}</td>
                        <td>{{ d?.revenueCode }}</td>
                        <td>{{ d?.timeCreated | date }}</td>
                        <td>{{ currencySymbol }}{{ d?.transactionAmount | amount }}</td>
                        <td>
                            <span
                                class="badge {{ d?.paymentStatus == 'PAID' ? 'bg-success' : d?.paymentStatus == 'NOT_PAID' ? 'bg-danger' : 'bg-warning' }}">
                                {{ d?.paymentStatus | removeUnderscores }}
                            </span>
                        </td>
                        <td class="user-type-td">
                            <div ngbDropdown class="d-inline">
                                <button class="btn btn-success btn-sm btn-flat" id="dropdownBasic1" ngbDropdownToggle
                                    type="button">
                                    Action
                                </button>
                                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-flat">

                                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-flat">

                                        <a (click)="viewDetails(d)"
                                            style="font-family: Inter; font-size: 14px; font-style: normal;"
                                            ngbDropdownItem class="dropdown-item-flat pointer">
                                            View Details
                                        </a>
                                        <a *ngIf="d?.paymentStatus != 'PAID'" (click)="payOnline(d)"
                                            style="font-family: Inter; font-size: 14px; font-style: normal;"
                                            ngbDropdownItem class="dropdown-item-flat pointer">
                                            Pay Online
                                        </a>
                                        <a *ngIf="d?.paymentStatus != 'PAID'" (click)="selectId(d); openPayment(verify_payment)"
                                            style="font-family: Inter; font-size: 14px; font-style: normal;"
                                            ngbDropdownItem class="dropdown-item-flat pointer">
                                            Manual Reconciliation
                                        </a>
                                        <a (click)="downloadNotice(d.id, d.taxpayerAsin)"
                                            style="font-family: Inter,serif; font-size: 14px; font-style: normal;"
                                            ngbDropdownItem class="dropdown-item-flat pointer">
                                            Download Demand Notice
                                        </a>

                                        <a *ngIf="d?.paymentStatus == 'PAID' && d?.rrr"  (click)="downloadPaymentReceipt(d.rrr)"
                                            style="font-family: Inter,serif; font-size: 14px; font-style: normal;"
                                            ngbDropdownItem class="dropdown-item-flat pointer">
                                            Download Payment Receipt
                                        </a>
                                    </div>

                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </ng-container>
        </table>

        <!--        <div-->
        <!--                class="d-flex justify-content-center mt-3"-->
        <!--        >-->
        <!--            <p *ngIf="isSearching" class="text-muted">Please wait...</p>-->
        <!--            <p *ngIf="isEmpty" class="text-danger">No Payment found</p>-->
        <!--        </div>-->


        <div class="pagination justify-content-end">
            <ngb-pagination *ngIf="!isSearching && details?.length > 0" class="d-flex justify-content-center my-3"
                [(page)]="currentPage" (pageChange)="callDb($event)" [maxSize]="5" [pageSize]="pageSize"
                [collectionSize]="count" [boundaryLinks]="true" [directionLinks]="true" [rotate]="true">
            </ngb-pagination>
        </div>

    </div>
</div>

<ng-template #generate_bill  let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Verify ASIN</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
            <img src="assets/img/icon_cancel.png" alt="close icon">
        </button>
    </div>

    <div class="modal-body">
        <form [formGroup]="asinForm">
            <div class="col-md-10">
                <label class="fw-bold fs-18 my-2">Enter ASIN</label>
                <div class="input-group">
                    <input type="text" class="form-control  small-option-font me-2" placeholder="Enter ASIN"
                        formControlName="asin">
                    <div class="input-group-append text-center">
                        <button (click)="verifyAsin()" class="btn custom-btn btn-sm fs-11">
                            <ng-container *ngIf="searching">
                                <span><span class="iconify icon"
                                        data-icon="eos-icons:bubble-loading"></span></span>
                            </ng-container>
                            Verify ASIN
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>

</ng-template>


<app-footer *ngIf="hasAccess(['ADMIN'])"></app-footer>
<app-mda-footer *ngIf="hasAccess(['MDA'])"></app-mda-footer>

<ng-template #noDataTemplate>
    <tr>
        <td colspan="100%">
            <div class="d-flex justify-content-center align-items-center my-3">
                <ng-lottie containerClass="mx-auto" [options]="{ path: lottiePath, autoplay: true, loop: true }"
                    class="lottie-animation"></ng-lottie>
                <div class="message">Searching</div>
            </div>
        </td>
    </tr>
</ng-template>

<ng-template #loading>
    <select class="form-control">
        <option [value]="''" disabled selected> Loading...</option>
    </select>
</ng-template>

<ng-template #verify_payment let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Verify Payment</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
            <img src="assets/img/icon_cancel.png" alt="close icon">
        </button>
    </div>

    <div class="modal-body">
        <form [formGroup]="paymentReferenceForm" (ngSubmit)="confirmPaymentReference()">
            <div class="row mt-2 mb-3">
              
                <div class="row mt-2">
                    <div class="col-md-12 ">
                        <label>Payment Reference<span class="text-danger">*</span></label>
                        <input type="text" class="form-control custom-input small-option-font" placeholder="Enter Payment Reference"
                               formControlName="rrr">
                        <div
                                *ngIf="paymentReferenceForm.get('rrr').invalid && (paymentReferenceForm.get('rrr').dirty || paymentReferenceForm.get('rrr').touched)">
                        <span *ngIf="paymentReferenceForm.get('rrr').hasError('required')"
                              class="error-text">Payment Reference is required.</span>
                        </div>
                    </div>
                </div>
            </div>

        
            <div class="col-md-12">
                <button [disabled]="!paymentReferenceForm.valid" type="submit"
                        class="btn custom-btn-continue btn-md mt-4">
                        <b *ngIf="!isVerifyingRrr">Verify</b>
                        <b *ngIf="isVerifyingRrr"  class="spinner-border text-dark"></b>
                   
                </button>
            </div>
        </form>
    </div>

</ng-template>